/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Dayjs } from "dayjs";
import useConfig from "../../../../actions/Tenants/config/configHook";
import { getFilledArrayOrDefault } from "../../../../utils";
import { ClassDistribution } from "../Helpers/ClassDistribution";
import { getRipeningClasses, RipeningDenominator } from "../hooks/getRipeningClasses";
import { formatDate } from "../hooks/useRipeningRoom";

export function RipeningDayPlanning({
    selected,
    date,
    pallets,
    ripeningField,
    showPercent,
    setShowPercent,
    hideNumberOfCheckedPallets = true
}: {
    selected: boolean;
    date: Dayjs;
    pallets: any[];
    ripeningField: string;
    showPercent: boolean;
    hideNumberOfCheckedPallets?: boolean;
    setShowPercent: (value: boolean | ((prev: boolean) => boolean)) => void;
}) {
    const config = useConfig();
    const glowingEffect = selected ? "box-shadow: 0px 0px 8px 8px rgba(19, 165, 95, 0.1);" : "";

    const titleBackgroundClass = selected ? "text-white" : "bg-light";
    const denominator = config.root_config?.ripening_room_denominator_for_relative_classes || RipeningDenominator.checked_pallets;

    const totalPallets = getFilledArrayOrDefault(pallets).length;
    const { classes, total } = getRipeningClasses({
        pallets,
        ripeningField,
        date,
        denominator
    });

    return (
        <div
            className="cursor-pointer rounded bg-white"
            css={[css`${glowingEffect}`, css`width: 280px;box-shadow: 0px 0px 5px rgba(19, 165, 95, 0.2);`]}
        >
            <div
                className={`p-2 rounded-top text-center ${titleBackgroundClass}`}
                css={css`background-color: ${selected ? "#13A55F" : "#f8f9fa"};`}
            >
                <span>{formatDate(date)}</span>
            </div>

            <div
                className="mb-1 font-weight-bold p-2 pt-3"
                css={css`min-height: 136px; font-size: 14px; `}
                onClick={() => setShowPercent((prev) => !prev)}
            >
                <ClassDistribution
                    classes={classes}
                    total={total}
                    totalPallets={totalPallets}
                    denominator={denominator}
                    showPercent={showPercent}
                    hideNumberOfCheckedPallets={hideNumberOfCheckedPallets}
                />
            </div>
        </div>
    );
}
